const Data = [
  {
    name: "Agam Anil Sukhadeve",
    position: "UG Coordinator",
    imageUrl: "/assets/images/members/Heads26/AgamAnilSukhadeve.png",
    facebookLink: "https://www.facebook.com/share/18X7p6RfhG/",
    email: "agamsukhadeve0@gmail.com",
    linkedinLink: "https://www.linkedin.com/in/agam-sukhadeve-8386ab323?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  },
  {
    name: "Gopanshu Garg",
    position: "UG Coordinator",
    imageUrl: "/assets/images/members/Heads26/GopanshuGarg.jpg",
    facebookLink: "",
    email: "mkkumar04157.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/gopanshu-garg-9ba27a326?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },
  {
    name: "Komal Godara",
    position: "UG Coordinator",
    imageUrl: "/assets/images/members/Heads26/KomalGodara.jpg",
    facebookLink: "https://www.facebook.com/share/1AwFV4ZovW/",
    email: "komal2006.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/komal-godara-b2a516346?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  }
];

export default Data;